export default {
    clearCustomerFormSubmissionsFilters: (state: any) => {
        state.queryParams = {
            page: 1,
            limit: 50,
            sortDirection: 'DESC',
            typeId: null,
            email: null,
            processed: null,
            createdAtMin: null,
            createdAtMax: null,
        };
    },
    setCustomerFormSubmissionsList: (state: any, action: any) => {
        state.list = action.payload;
    },
};
